import { AppRoutes } from "./routing";
import { BrowserRouter as Router } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";

function App() {
  return (
    <SearchProvider>
      <Router basename="/">
        <AppRoutes />
      </Router>
    </SearchProvider>
  );
}

export default App;
